import { render, staticRenderFns } from "./KpiSettingStaff.vue?vue&type=template&id=19e61403"
import script from "./KpiSettingStaff.vue?vue&type=script&lang=js"
export * from "./KpiSettingStaff.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports